import React, { useEffect, useState } from 'react';
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import Helper from "src/helper/Helper";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

export function SearchBom() {
    const defaultModel = { bomId: "" };
    const [searchData, setSearchData] = useState(defaultModel);
    const [{ filter_list }, { }, { set_filter_list }] = useObjCommonFilterStore();
    const [{ }, { system_alert_indicator ,clear_all_system_alert}, { }] = useDOMAttachToSystemStore();

    useEffect(() => {
        if (!filter_list || Object.entries(filter_list).length === 0) {
            setSearchData(defaultModel);
        } else {
            const searchingData = defaultModel;
            searchingData.bomId = filter_list?.bomId?.searchKeyword ? filter_list?.bomId?.searchKeyword : '';
            setSearchData(searchingData);
        }
    }, [filter_list]);

    const onSearch = (e) => {
        e.preventDefault();

        const isSearchDataEmpty = Object.values(searchData).every(
            (value) => !value
        );

        if (isSearchDataEmpty) {
            system_alert_indicator({
                name: 'bomManager',
                message: "Please enter the complete BOM ID.",
                type: "danger",
                isDisplayIcon: true,
                isDisplay: false,
            })
            return;
        }

        const keyToSearchType = {
            bomId: "BOM ID"
        };
        const filterList = Object.entries(searchData)
            .filter(([key, value]) => Helper.valueIsNotNull(value)).map((v) => {
                return {
                    searchType: keyToSearchType[v[0]],
                    key: v[0],
                    searchKeyword: v[1],
                };
            });

        const filterListObject = filterList?.reduce((acc, curr) => {
            acc[curr.key] = curr;
            return acc;
        }, {});


        clear_all_system_alert({})
        set_filter_list(filterListObject);
    };
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setSearchData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    return (
        <>
            <div className="bg-grey2">
                <div className="container">
                    <div className="accordion-item ">
                        <h2 className="accordion-header" id="searchInput">
                            <button
                                className="accordion-button"
                                type="button"
                                data-toggle="collapse"
                                data-target="#collapseSearch"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                            >
                                <b className="font-16">Search</b>
                            </button>
                        </h2>

                        <div
                            id="collapseSearch"
                            className="accordion-collapse collapse in"
                            aria-labelledby="searchInput"
                            data-parent="#accordionExample"
                        >
                            <div className="accordion-body p-0">
                                <form
                                    onSubmit={(e) => {
                                        onSearch(e);
                                    }}
                                >
                                    <div className="row bs5 m-t-30 ms-0 me-0">
                                        <div className="col-sm-12 col-md-5 mb-2 usersearch-container">
                                            <label htmlFor="bomId">BOM ID *</label>
                                            <input
                                                className="ps-2 form-control form-control-sm mb-0"
                                                name="bomId"
                                                placeholder="BOM ID"
                                                type="text"
                                                value={searchData.bomId}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div class="co-md-12"></div>
                                        <div className="col-sm-12 col-md-5 text-sm-end pe-0 mt-2 pb-4">
                                            <button className="btn btn-secondary bs5 minw140">Search</button>
                                        </div>
                                    </div>

                                    
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
